//
import WhDispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'

//
export default class WhDispatchRequestToList extends WhDispatchRequestModel {

    /**
     *
     */
    static includes = [
        'g_state',
        //'pch_payment_condition',
        //'pos_sale.g_seller_user.hr_employee',
        //'pos_sale.payment_types',
        //'pos_sale.pos_detail_sales.wh_product',
        'sl_customer',
        'sl_sale_invoice',
        'sl_sale_ticket',
        //'sl_customer_branch_offices',
        //'wh_detail_dispatch_requests.wh_product',
        //'wh_detail_dispatch_requests.wh_warehouse',
    ]

    get bill_state_str() {
        return this.sl_sale_ticket ? 'Boleteado' : this.sl_sale_invoice ? 'Facturado' : '-'
    }
}
